module.exports = __webpack_public_path__ + "static/media/closed-captioning.3fcceae3.svg";